import RelatedProducts from "./RelatedProducts";
import compose from "recompose/compose";
import withProps from "recompose/withProps";
import lifecycle from "recompose/lifecycle";
import withState from "recompose/withState";
import get from "lodash/get";
import formatPrismicData from "../../hocs/formatPrismicData";
import withFilteredProductItems from "../../hocs/withFilteredProductItems";
import { withUser } from "../../data-providers/user";
import { withUserOrders } from "../../data-providers/orders";
import withCountry from "../../hocs/withCountry";
import product from "../../../facades/prismic/product";
import cookieFactory from "../../../cookieFactory";
import logger from "../../../../../logger";

const enhance = compose(
  formatPrismicData,
  withUser,
  withUserOrders,
  withCountry,
  withState("items", "setItems", (props) => props.items),
  withState("isLoading", "setIsLoading", (props) => props.useUserOrders),
  withFilteredProductItems,
  withProps((props) => ({
    ...props,
    showArrow: true,
  })),
  lifecycle({
    componentDidMount() {
      // Check if user is logged out
      if (!!cookieFactory("restricted_user_id").get()) {
        this.props.setIsLoading(false);
      }
    },
    async componentDidUpdate(prevProps) {
      const props = this.props;

      if (
        props.useUserOrders &&
        prevProps.isLoggedIn !== props.isLoggedIn &&
        props.isLoggedIn
      ) {
        try {
          let { orders } = await props.fetchUserOrders();
          if (orders.length > 0) {
            const latestOrder = orders[0];
            const latestOrderId = latestOrder.id;

            const order = await props.fetchUserOrder(
              latestOrderId,
              props.userOrders
            );

            const firstItem = order.items[0] || {};
            const productSku = get(firstItem, "format.product.id", "");

            if (productSku) {
              const prismicProductResponse = await product.get(
                productSku,
                props.country.contentLocales[0]
              );
              const prismicProductDocument = prismicProductResponse.body;
              const relatedProducts =
                get(prismicProductDocument, "relatedProducts.items") || [];

              if (relatedProducts.length > 0) {
                props.setItems(relatedProducts);
              }
            }
          }
        } catch (err) {
          logger.warn(
            "Failed to fetch prismic data based on order information",
            err
          );
        }

        if (props.isLoading) {
          props.setIsLoading(false);
        }
      }
    },
  })
);

export default enhance(RelatedProducts);
